// import enterpriseFtList from '../components/enterpriseFt/enterpriseFtList.vue'
// import viewEnterpriseFt from '../components/enterpriseFt/viewEnterpriseFt.vue'

export default [
    {
        path: 'enterpriseFt/enterpriseFtList',
        component: resolve => require(['@/components/enterpriseFt/enterpriseFtList'],resolve),
        name:"EnterpriseFtList",
        meta:{
            id:'637',
            node:'enterpriseFt',
            url:'enterpriseFtList',
        }
    },
    {
        path: 'enterpriseFt/viewEnterpriseFt',
        component: resolve => require(['@/components/enterpriseFt/viewEnterpriseFt'],resolve),
        name:"ViewEnterpriseFt",
        meta:{
            // id:'637',
            node:'enterpriseFt',
            url:'viewEnterpriseFt',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/enterpriseFt.js